import React from 'react';
import PropTypes from 'prop-types';
import {DragSource, DropTarget} from 'react-dnd';

import DragHandle from 'app/components/common/drag-handle';
import utils      from 'app/helpers/utils';



class SortableItemRaw extends React.PureComponent {
  onDrop({index: itemIndex}) {
    this.props.onDrop(itemIndex, this.props.index);
  }
  render() {
    const {
      connectDropTarget, connectDragSource, connectDragPreview, distinctHandle,
      isTarget, isActive, isSource,
      index, item, renderItem,
      isSourceBefore, isSourceAfter,
    } = this.props;
    const activeClass = isActive ? 'dnd-active' : '';
    const targetClass = isTarget ? 'dnd-target' : '';
    const sourceClass = isSource ? 'dnd-source' : '';
    const dirClass = (() => {
      if (!isTarget) return '';
      if (isSourceBefore) return 'dnd-source-before';
      if (isSourceAfter)  return 'dnd-source-after';
      return '';
    })();
    const className = `${activeClass} ${targetClass} ${sourceClass} ${dirClass}`;
    let handleEl = <div className="sortlist-handle-con"><DragHandle className="sortlist-handle" /></div>;
    if (distinctHandle) handleEl = connectDragSource(handleEl);
    const dnd = {className, isActive, isTarget, isSource, handleEl};
    const content = renderItem(item, index, dnd);
    return distinctHandle
      ? connectDragPreview(connectDropTarget(content))
      : connectDragSource(connectDropTarget(content));
  }
}
const dropSpec = {
  drop: (props, monitor, component) => {
    component.onDrop(monitor.getItem());
  },
  // hover: (props, monitor, component) => {},
  // canDrop: (props, monitor) => {},
};
const dragSpec = {
  beginDrag: (props, monitor, component) => {
    props.onDragStart();
    return {index: props.index};
  },
  endDrag: (props, monitor, component) => {
    props.onDragEnd();
  },
  // canDrag: (props, monitor) => {},
};
const dropToProps = (connect, monitor, props) => ({
  connectDropTarget: connect.dropTarget(),
  isTarget: monitor.isOver(),
  isActive: monitor.canDrop(),
  isSourceBefore: monitor.getItem() && monitor.getItem().index < props.index,
  isSourceAfter:  monitor.getItem() && monitor.getItem().index > props.index,
});
const dragToProps = (connect, monitor, props) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isSource: monitor.isDragging(),
});

// react-dnd requires a key to associate sources and targets - a source with key X can be dropped on any target with key X
// if we have 2 instances of <SortableList /> mounted at the same time, we don't want an item from one list to be dropped into the other list
const makeSortableItemComp = () => {
  const dndKey = utils.clientId();
  return DragSource(dndKey, dragSpec, dragToProps)(DropTarget(dndKey, dropSpec, dropToProps)(SortableItemRaw));
};



class SortableList extends React.PureComponent {

  constructor(props) {
    super(props);

    this.SortableItem = makeSortableItemComp();

    this.onDrop = this.onDrop.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDrop(sourceIndex, dropIndex) {
    const items = [...this.props.items];
    // sanity check
    if (sourceIndex > (items.length - 1)) return;
    if (dropIndex > (items.length - 1)) return;
    // don't do a swap; do a shift
    const sourceItem = items[sourceIndex];
    items.splice(sourceIndex, 1);
    items.splice(dropIndex, 0, sourceItem);
    this.props.onSort(items);
  }

  onDragStart() {
  }

  onDragEnd() {
  }

  render() {
    const {items, renderItem, distinctHandle, forceUpdate} = this.props;
    const {SortableItem} = this;
    return (<>
      {items.map((item, i) => {
        return (
          <SortableItem
            key={i}
            index={i}
            item={item}
            renderItem={renderItem}
            onDrop={this.onDrop}
            onDragStart={this.onDragStart}
            onDragEnd={this.onDragEnd}
            distinctHandle={distinctHandle}
            forceUpdate={forceUpdate}
          />
        );
      })}
    </>);
  }

}

// "active" - a dnd operation is happening (items should indicate they're slots that can be dropped into)
// "source" - the item being drug
// "target" - the slot an item is being drug into (currently hovered over with an active dnd)
SortableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  renderItem: PropTypes.func.isRequired, // (item, index, {isActive, isTarget, isSource, className, handleEl}) => Node
  onSort: PropTypes.func.isRequired, // (items) => any
  distinctHandle: PropTypes.bool, // when true, you must click on the handle element to begin a drag
  forceUpdate: PropTypes.number, // update this value to force a re-render
};
SortableList.defaultProps = {
  distinctHandle: false,
  forceUpdate: 0,
};

export default SortableList;
